import type { PropsWithChildren } from "react";
import { LoadingContext } from "#/utils/context/loading";

export const LoadingProvider = ({ children }: PropsWithChildren) => {
  return (
    <LoadingContext.Provider
      value={{
        showLoading: () => {},
        hideLoading: () => {},
        isLoading: false,
      }}
    >
      {children}
    </LoadingContext.Provider>
  );
};
